// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3-AYa","requiredAsterisk":"Info_requiredAsterisk__5NRKk"};